"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Avatar_1 = __importDefault(require("atomicComponents/atoms/Avatar"));
var AvatarGroup_1 = __importDefault(require("atomicComponents/atoms/Avatar/AvatarGroup"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var SkeletonGroup_1 = __importDefault(require("atomicComponents/atoms/Skeleton/SkeletonGroup"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var Money_1 = __importDefault(require("components/Money"));
var PREFIX = 'TeamHeader';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    teamName: "".concat(PREFIX, "-teamName"),
    spendSummary: "".concat(PREFIX, "-spendSummary"),
    noData: "".concat(PREFIX, "-noData"),
    defaultAnnualSpend: "".concat(PREFIX, "-defaultAnnualSpend"),
    popup: "".concat(PREFIX, "-popup"),
};
var StyledGrid = (0, styles_1.styled)(material_1.Grid)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            padding: theme.spacing(0, 1),
        },
        _b[".".concat(classes.teamName)] = {
            fontWeight: theme.typography.fontWeightMedium,
            margin: 0,
            whiteSpace: 'nowrap',
        },
        _b[".".concat(classes.spendSummary)] = {
            fontWeight: theme.typography.fontWeightMedium,
            whiteSpace: 'nowrap',
            textAlign: 'right',
        },
        _b[".".concat(classes.noData)] = {
            borderRadius: 12,
            backgroundColor: theme.palette.grey[500],
            padding: theme.spacing(1),
        },
        _b[".".concat(classes.defaultAnnualSpend)] = {
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.grey[500],
        },
        _b[".".concat(classes.popup)] = {
            '& p': {
                color: theme.palette.common.white,
            },
        },
        _b);
});
var TeamHeader = function (_a) {
    var team = _a.team, teamLeadProfile = _a.teamLeadProfile, teamMembersProfile = _a.teamMembersProfile, teamServices = _a.teamServices, leadEmail = _a.leadEmail, isLeadPopupOpen = _a.isLeadPopupOpen;
    var annualSpent = teamServices === null || teamServices === void 0 ? void 0 : teamServices.reduce(function (acc, curr) { return acc + (curr.calculatedAnnualSpend || 0); }, 0);
    var popupTitle = leadEmail && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 2, className: classes.popup }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ style: { fontWeight: 600 }, align: "center" }, { children: leadEmail })), (0, jsx_runtime_1.jsx)(material_1.Box, { mt: 2 }), (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ align: "center" }, { children: [team === null || team === void 0 ? void 0 : team.name, " Lead"] }))] })));
    var getTeamLeadAvatar = function () {
        var name = (0, end2end_1.getDisplayName)(teamLeadProfile) || leadEmail;
        if (name) {
            return (0, jsx_runtime_1.jsx)(Avatar_1.default, { label: name });
        }
        return (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 });
    };
    return ((0, jsx_runtime_1.jsxs)(StyledGrid, __assign({ container: true, alignItems: "center", wrap: "nowrap", justifyContent: "space-between", className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (team === null || team === void 0 ? void 0 : team.name) ? (0, jsx_runtime_1.jsx)("h3", __assign({ className: classes.teamName }, { children: team.name || '' })) : (0, jsx_runtime_1.jsx)(material_1.Box, { ml: 0.5, width: "50%", className: classes.noData }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 4, item: true, container: true, alignItems: "center", wrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ placement: "bottom", variant: "dark", open: isLeadPopupOpen, title: popupTitle || '', arrow: true, disableHoverListener: true }, { children: (0, jsx_runtime_1.jsx)("div", { children: getTeamLeadAvatar() }) })), !teamMembersProfile && ((0, jsx_runtime_1.jsx)(SkeletonGroup_1.default, { children: __spreadArray([], __read(Array(5).keys()), false).map(function (el) { return ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 }, el)); }) }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 4, item: true, container: true, alignItems: "center", justifyContent: "flex-end", wrap: "nowrap" }, { children: [(teamServices === null || teamServices === void 0 ? void 0 : teamServices.length)
                        ? ((0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ className: classes.spendSummary }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: annualSpent, isShortened: true }), " LTM ", (0, jsx_runtime_1.jsx)("span", { children: "\u00B7" }), teamServices === null || teamServices === void 0 ? void 0 : teamServices.length] })))
                        : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1", className: classes.defaultAnnualSpend }, { children: "$" })), (0, jsx_runtime_1.jsx)(material_1.Box, { className: classes.noData, mx: 1, width: 50 }), (0, jsx_runtime_1.jsx)(material_1.Box, { className: classes.noData, mr: 0.5, width: 30 })] })), teamServices && teamServices.length > 0
                        ? ((0, jsx_runtime_1.jsx)(AvatarGroup_1.default, __assign({ max: 5 }, { children: teamServices === null || teamServices === void 0 ? void 0 : teamServices.map(function (teamService) { return (0, jsx_runtime_1.jsx)(Logo_1.default, { brand: teamService.service }, teamService.id); }) })))
                        : ((0, jsx_runtime_1.jsx)(SkeletonGroup_1.default, { children: __spreadArray([], __read(Array(5).keys()), false).map(function (el) { return ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 }, el)); }) }))] }))] })));
};
exports.default = TeamHeader;
